/**
 * @prettier
 */

/**
* Web Service handler to retrieve and represent a list of resources, grouped by queue->TT->resource
*
* @class ResourceBinderWS
*/
var ResourceBinderWS = function (viewModel, addAppointmentViewModel) {
	var self = this; // Convenience reference so the context of 'this' becomes clearer
  this.addAppointmentViewModel = addAppointmentViewModel;

	// Predicate this Web Service handler on the Abstract class of a Web
	// Service handler. This establishes core functionality required of
	// these such handlers, which can be overwritten by methods below.
	AbstractWS.apply( this, arguments );

	self.parent			= parent;

	self.resources		= ko.observableArray( [] );


	// Specifies this service's API endpoint
  self.serviceURL = ko.computed(function () {
    if (self.addAppointmentViewModel && self.addAppointmentViewModel.location()) {
      return "/qless/api/v1/appointment/queuesTransactionTypesResources/" + self.addAppointmentViewModel.location().id;
		}

		return null;
	});


	/**
	* Locates a resource by it's ID
	*
	* @method getResourceById
	* @param {Number} id
	* @return {Object | Null}
	*/
	self.getResourceById = function ( id ) {
		var i = 0;

		for ( i = 0; i < self.resources().length; i++ ) {
			if ( self.resources()[i].id == id ) {
				return self.resources()[i];
			}
		}

		return null;
	};


	/**
	* This method iterates over the data returned from the service and
	* converts the individual nodes into models which can be consumed by
	* the UI
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return none
	*/
	self.processData = function ( xmlData ) {
		var i = 0,
			j = 0,
			k = 0,
			queueId = null,
			queues = [],
			resource = null,
			resourceId = null,
			resourceIds = [],
			resourceIdx = null,
			resources = [],
			rArr =[],
			ttId = null,
			tts = [];

		self.resources.removeAll();

		// Call the superclass method to perform any core actions
		AbstractWS.prototype.processData.call(self, xmlData);

		// Grab all the queue elements
		queues = $(xmlData).find('queue');

		if ( queues.length > 0 ) {
			// Loop over all found queues
			for ( i = 0; i < queues.length; i++ ) {
				queueId = Number( queues[i].getAttribute('id') );

				tts = $(queues[i]).find('transactionType');

				// Loop over all found Transaction Types
				for ( j = 0; j < tts.length; j++) {
					ttId = Number( tts[j].getAttribute('id') );

					resources = $(tts[j]).find('resource');

					// Loop over all found resources
					for ( k = 0; k < resources.length; k++ ) {
						resourceId = Number( resources[k].getAttribute('id') );
						resourceIdx = resourceIds.indexOf( resourceId );

						if ( resourceIdx > -1 ) {
							if ( rArr[ resourceIdx ].queues.indexOf( queueId ) == -1 ) {
								rArr[ resourceIdx ].queues.push( queueId );
							}

							if ( rArr[ resourceIdx ].transactionTypes.indexOf( ttId ) == -1 ) {
								rArr[ resourceIdx ].transactionTypes.push( ttId );
							}
						}
						else {
							resourceIds.push( resourceId );

							var resource = {};
							resource.queues = [ queueId ];
							resource.transactionTypes = [ ttId ];
							resource.description = resources[k].getAttribute('description');
							resource.id = resourceId;

							rArr.push( resource );

						}

					}
				}
			}
			rArr.sort( self.sortByDescription );

			self.resources( rArr );
		}
	};


	/**
	* Sorting function
	*
	* @method sortByDescription
	* @param {Object} a
	* @param {Object} b
	* @return {Number}
	*/
	self.sortByDescription = function ( a, b ) {
		return ( a.description > b.description ) ? 1 : ( ( a.description < b.description ) ? -1 : 0 );
	};

	return self;
};

ResourceBinderWS.prototype = AbstractWS.prototype;
ResourceBinderWS.prototype.constructor = ResourceBinderWS;
